"use client";

import { useContext } from "react";
import { TextField, Autocomplete } from "@mui/material";
import { FilterParamsContext } from "../FilterParamsProvider";
import { ChannelType } from "@/interfaces/channelType";

export default function ChannelTypeSelectClient({
  options,
}: {
  options: ChannelType[];
}) {
  const channelTypeMap = new Map(
    [...options]
      .sort((a, b) => a.name.localeCompare(b.name))
      .map((geography) => [geography.id, geography]),
  );
  const { filterParams, setFilterParams } = useContext(FilterParamsContext);

  return (
    <Autocomplete
      multiple
      options={Array.from(channelTypeMap.keys())}
      value={filterParams.channel_types}
      onChange={(_event, newValue) => {
        setFilterParams({
          ...filterParams,
          channel_types: [...newValue].sort((a, b) => {
            const channelTypeA = channelTypeMap.get(a);
            const channelTypeB = channelTypeMap.get(b);
            return (channelTypeA?.name || "").localeCompare(
              channelTypeB?.name || "",
            );
          }),
        });
      }}
      renderInput={(params) => <TextField {...params} label="Channel Type" />}
      getOptionLabel={(option) => channelTypeMap.get(option)?.name || ""}
      getOptionKey={(option) => channelTypeMap.get(option)?.id || Date.now()}
      disableCloseOnSelect
    />
  );
}
